import { sendGet } from "../base";
import { getAPIData } from "../helpers";

export const getSidebarCountProduct = () => getAPIData(sendGet("reviews/sidebar_count/products/"));